import { EnableablePreference } from "./EnableablePreference";
import { User } from "./User";

export interface Affiliate {
    id: ID;
    name: string;
    email?: string | null;
    phone: string;
    url: string;
    address: string;
    notes: string;
    code: string;
    status: AffiliateStatus;
    user?: User;
    children?: string[];
    parent?: string;
    delegated: boolean;
    affiliateNotification?: EnableablePreference;
    travelerNotification?: EnableablePreference;
    deposit?: AffiliateDeposit;
    voucher?: boolean;
    purchaseRulesPermanentIds?: string[];
    purchaseRules?: Array<{ id: ID }>;
    allowChildren?: boolean;
    object?: "affiliate";
}

export interface AffiliateDeposit {
    id?: ID;
    amount: number;
    enabled: boolean;
    amountType: AffiliateDepositAmountType;
    depositType: AffiliateDepositType;
    scope: AffiliateDepositScope;
    validate: boolean;
}

export enum AffiliateStatus {
    ACTIVE = "active",
    INACTIVE = "inactive",
}

export enum AffiliateDepositAmountType {
    ABSOLUTE = "absolute",
    PERCENT = "percent",
    CUSTOM = "custom_amount",
}

export enum AffiliateDepositScope {
    PERSON = "person",
    OUTING = "outing",
}

export enum AffiliateDepositType {
    TOTAL = "total_order_amount",
    COMMISSION = "commission_amount",
    CUSTOM = "custom_amount",
}

export const AffiliateDepositTypeCopy = {
    [AffiliateDepositType.COMMISSION]: "Commission Amount",
    [AffiliateDepositType.TOTAL]: "Total value of booking",
};

// CA + EA
